import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicSelectableModule } from 'ionic-selectable';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { NgxErrorsModule } from '@hackages/ngxerrors';
import { IonicStorageModule } from '@ionic/storage';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import 'chartjs-plugin-zoom';
import { NgxKjuaModule } from 'ngx-kjua';
import { ReportFiltersMobilePageModule } from './pages/admin/report-filters-mobile/report-filters-mobile.module';
import { ReportSubscriptionsDetailPageModule } from './pages/admin/report-subscriptions-detail/report-subscriptions-detail.module';
import { ReportZoomPageModule } from './pages/admin/report-zoom/report-zoom.module';
import { SupportImgViewPageModule } from './pages/admin/support-img-view/support-img-view.module';
import { ManagerConfigRelaysPageModule } from './pages/manager/manager-config-relays/manager-config-relays.module';
import { ManagerCouponsSharePageModule } from './pages/manager/manager-coupons-share/manager-coupons-share.module';
import { ManagerPackagesSubscriptionsPageModule } from './pages/manager/manager-packages-subscriptions/manager-packages-subscriptions.module';
import { ManagerParkingTicketsPageModule } from './pages/manager/manager-parking-tickets/manager-parking-tickets.module';
import { ManagerReportsDetailPageModule } from './pages/manager/manager-reports-detail/manager-reports-detail.module';
import { ManagerSchedulePageModule } from './pages/manager/manager-schedule/manager-schedule.module';
import { InstallationMenuDetailPageModule } from './pages/public/installation-menu-detail/installation-menu-detail.module';
import { CustomCurrencyPipe } from './pipes/currency.pipe';

import { NgxImageCompressService } from 'ngx-image-compress';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, CustomCurrencyPipe],
  entryComponents: [],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxErrorsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    SharedComponentsModule,
    SharedDirectivesModule,
    IonicSelectableModule,
    IonicModule.forRoot({
      backButtonText: ''
    }),
    IonicStorageModule.forRoot({
      name: 'sipass',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ServiceWorkerModule.register('ngsw-worker.js',
      { enabled: environment.production }
    ),
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    NgxKjuaModule,
    NgxDatatableModule,
    InstallationMenuDetailPageModule,
    ManagerParkingTicketsPageModule,
    ManagerReportsDetailPageModule,
    ReportSubscriptionsDetailPageModule,
    ReportFiltersMobilePageModule,
    ManagerPackagesSubscriptionsPageModule,
    ManagerCouponsSharePageModule,
    ManagerSchedulePageModule,
    ManagerConfigRelaysPageModule,
    SupportImgViewPageModule,
    ReportZoomPageModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    NgxImageCompressService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
